import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'gdp-coupon-metadata-form',
  templateUrl: './coupon-metadata-form.component.html',
  styleUrls: ['./coupon-metadata-form.component.scss']
})
export class CouponMetadataFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public loading: boolean = false;
  @Output() emitValue: EventEmitter<any> = new EventEmitter();

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      it: this.fb.group({
        title: [null, Validators.required],
        subtitle: [null, Validators.required],
        cta: [null, Validators.required]
      }),
      en: this.fb.group({
        title: [null, Validators.required],
        subtitle: [null, Validators.required],
        cta: [null, Validators.required]
      })
  });
  }

  isFieldInvalid(name: string, nation: string) {
    const formGroup = this.form.controls[nation] as UntypedFormGroup;
    const control = formGroup.controls[name];
    return (control.invalid && control.dirty);
  }

  generateMetadata() {
    if(this.form.valid) {
      const value = this.form.value;
      const payload = {
        ...value
      }
      this.emitValue.emit(payload);
    }
  }

}
